module.exports = __webpack_public_path__ + "static/media/dog3.90b7b001.jpg";